// Stores
import { useResult } from "../../../../shared/formContext/hooks/useResult";

// Components
import ChartLine from './../../../../components/ChartLine/ChartLine.js';
import ChartLegend from './../../../../components/ChartLegend/ChartLegend.js';

// Utils
import { utils } from "../../../../helpers/index.js";

// WP react stuff
import { useState, useEffect } from '@wordpress/element';
import { __, sprintf } from "@wordpress/i18n";

const TabAmortizacao = () => {
    const { resultData } = useResult();
    const { response } = resultData;
    const [legends, setLegends] = useState();
    const [chartData, setChartData] = useState();

    useEffect(() => {
        const processInstallments = (installments) => {
            const flattened = [];
            Object.values(installments).forEach((yearData) => {
                Object.values(yearData.installments).forEach((installment) => {
                    flattened.push(installment);
                });
            });
            return flattened;
        };

        const processData = processInstallments(response?.data?.result?.installments || {})
        let totalPaid = 0
        let totalInterestPaid = 0

        setLegends(
          {
          [__('Total pago', 'df-simulators')]: {
            value: totalPaid,
            color: '#CCEBF5',
          },
          [__('Juros pagos', 'df-simulators')]: {
            value: totalInterestPaid,
            color: '#09C',
          },
          [__('Dívida', 'df-simulators')]: {
            value: response?.data?.result?.loan_value || 0,
            color: '#000031',
          },
        }
        );

        setChartData({
            labels: processData.map((item) => item.date),
            tooltip: {
              title: (tooltipItem) => sprintf(
                /* translators: 1: month number, 2: formatted date */
                __("Mês %1$d\n%2$s", "df-simulators"),
                tooltipItem[0].dataIndex + 1,
                utils.transformDate(tooltipItem[0].label, false, false, '-')
              ),
                label: () => false,
                callbackOnShow: (tooltipItem) => {

                    const key = tooltipItem.dataset.label;

                    setLegends(prevLegends => ({
                        ...prevLegends,
                        [key]: {
                            ...prevLegends[key],
                            value: tooltipItem.raw,
                        },
                    }));

                },
            },
            dataSets: [
                {
                    label: __('Total pago', "df-simulators"),
                    data: processData.map((item) => {
                        totalPaid += (item.installment_amount || 0);
                        return totalPaid;
                    }),
                    color: '#CCEBF5',
                },
                {
                    label: __('Juros pagos', "df-simulators"),
                    data: processData.map((item) => {
                        totalInterestPaid += item.interest_paid || 0;
                        return totalInterestPaid;
                    }),
                    color: '#09C',
                },
                {
                    label: __('Dívida', "df-simulators"),
                    data: processData.map((item) => item.remaining_balance),
                    color: '#000031',
                },
            ],
        });

    }, [response]);

    return <div className="tab-amortizacao">
        {chartData && <ChartLine data={chartData} />}
        {legends && <div className="mt-4 pt-4">
            <ChartLegend data={legends} horizontal showAll />
        </div>}
    </div>;
};

export default TabAmortizacao;
